import * as PIXI from "pixi.js";
import Layers from "./layers/Layers";
import InteracitivityComponent from "./InteractivityComponent";
import Animation from "./animation/Animation";
import TextureManager from "./managers/TextureManager";
import calcCanvasNewSize from "./utils/dom/calcNewCanvasSize";
import LoadingLayer from "./layers/LoadingLayer";
import { INITIAL_HEIGHT, INITIAL_WIDTH, ROOT_ASSETS_LIST } from "./types/Config";
import CustomCursor from "./entities/UI/CustomCursor/CustomCursor";
import checkVideoMode from "./helpers/checkVideoMode";


export default class Game extends PIXI.Application {
  static instance: Game;
  LoadingLayer!: LoadingLayer;
  WIDTH = INITIAL_WIDTH;
  HEIGHT = INITIAL_HEIGHT;
  LAYER_HEIGHT = INITIAL_HEIGHT;
  Animation = new Animation();
  CustomCursor!: CustomCursor;
  SCALE = 1;

  constructor(canvas: HTMLCanvasElement, infoSliderAssetsSlug: string, cb: () => void, extraAssets: string[] = []) {
    super();
    if (!Game.instance) {
      Game.instance = this;
    }

    this.calcGameSize();
    canvas.style.transform = `scale(${this.SCALE})`
    this.init({
      canvas,
      antialias: true,
      backgroundColor: 0xFFFFFF,
      width: this.WIDTH,
      height: this.HEIGHT
    }).then(() => {
      TextureManager
        .loadLogo()
        .then(async () => {
          const startGame = () => {
            new Layers();
            new InteracitivityComponent();
            cb();
            setTimeout(() => this.CustomCursor.setLayer(false), 300);
            checkVideoMode();
          }
          this.LoadingLayer = new LoadingLayer(() => startGame());
          this.CustomCursor = new CustomCursor();

          const infoSliderAssets = await TextureManager.getAssetsUrls(infoSliderAssetsSlug);
          const assets = ROOT_ASSETS_LIST.concat(extraAssets).concat(infoSliderAssets);
          TextureManager.load(assets, (p: number) => this.LoadingLayer.drawLoadingButton(p)).then(() => {
            console.log("loaded assets");
            this.ticker.add(delta => this.update(delta))
          });
        })
    })
  }
  static getInstance = (): Game => Game.instance;
  getDim = () => ({ WIDTH: this.WIDTH, HEIGHT: this.HEIGHT, LAYER_HEIGHT: this.LAYER_HEIGHT });
  private update = (delta: PIXI.Ticker) => this.Animation.update(delta.lastTime);

  calcGameSize() {
    const dims = calcCanvasNewSize(INITIAL_WIDTH, INITIAL_HEIGHT);
    Object.assign(this, dims);
  }
}

